import axios from 'axios';

export const penalizePostLite = id =>
  axios.post(`/lite/participations/${id}/conclude`);
